import React from 'react';

const ProfileTab = ({
  students,
  handleStudentClick,
  formatDate,
  handleEditHolyName,
  handleEditGender,
  handleEditDob,
  handleEditStatus
}) => {
  const formatGender = (gender) => {
    if (!gender) return 'Chưa có';
    const g = gender.toLowerCase();
    if (g === 'nam') return 'Nam 👦';
    if (g === 'nu' || g === 'nữ') return 'Nữ 👧';
    return gender;
  };

  return (
    <table className="student-table cs-profile-table">
      <thead>
        <tr>
          <th>STT</th>
          <th>Mã ID</th>
          <th>Tên Thánh</th>
          <th className="sticky-name-col">Họ và Tên</th>
          <th>Giới Tính</th>
          <th>Ngày Sinh</th>
          <th>Tình Trạng Học Tập</th>
        </tr>
      </thead>
      <tbody>
        {students.map((student, index) => (
          <tr key={student.id}>
            <td>{index + 1}</td>
            <td className="cs-id-cell">{student.id}</td>

            {/* Bấm trực tiếp vào Tên Thánh để sửa */}
            <td>
              <span
                className="cs-editable-text"
                onClick={() => handleEditHolyName(student)}
                title="Bấm để chỉnh sửa Tên Thánh"
              >
                {student.holyName || 'Chưa có'}
              </span>
            </td>

            {/* Họ và Tên (Cố định cuộn ngang & Xem chi tiết) */}
            <td className="sticky-name-col">
              <button
                className="student-name-link"
                onClick={() => handleStudentClick(student.id)}
                title="Bấm để xem hồ sơ chi tiết"
              >
                {student.fullName}
              </button>
            </td>

            {/* Bấm trực tiếp vào Giới tính để sửa */}
            <td>
              <span
                className={`cs-editable-pill cs-gender-pill ${student.gender === 'nu' || student.gender === 'nữ' ? 'gender-nu' : 'gender-nam'}`}
                onClick={() => handleEditGender(student)}
                title="Bấm để chỉnh sửa Giới tính"
              >
                {formatGender(student.gender)}
              </span>
            </td>

            {/* Bấm trực tiếp vào Ngày sinh để sửa */}
            <td>
              <span
                className="cs-editable-text"
                onClick={() => handleEditDob(student)}
                title="Bấm để chỉnh sửa Ngày sinh"
              >
                {formatDate(student.dateOfBirth)}
              </span>
            </td>

            {/* Bấm trực tiếp vào Trạng thái để sửa */}
            <td>
              <span
                className={`cs-editable-pill cs-status-badge ${student.status === 'Nghỉ luôn' ? 'status-off' : student.status === 'Tạm nghỉ' ? 'status-paused' : 'status-on'}`}
                onClick={() => handleEditStatus(student)}
                title="Bấm để chỉnh sửa Tình trạng"
              >
                ● {student.status || 'Còn đi học'}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProfileTab;